// Components==============
import { faBell } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { motion } from 'framer-motion';
import React, { memo, useRef } from 'react';
import { getTransparentBackground } from 'utilities/getTransparentBackground';
import { BellStatus } from '../Exercise';
import './Bell.module.scss';
// =========================

const inCorrectBase = {
    opacity: 1,
    scale: 1,
    transition: {
        duration: 0.6,
        type: 'tween',
    },
};

const correctBase = {
    opacity: 1,
    scale: 1,
    transition: {
        duration: 0.3,
        type: 'tween',
    },
};

function Bell({
    status,
    background,
}: {
    status: BellStatus;
    background?: Background;
}) {
    const ref = useRef<HTMLDivElement>(null);
    const elementWidth = ref.current?.clientWidth || 0;
    const gapWidth = 64;
    const x = elementWidth + gapWidth;

    const variants = {
        stale: { x: 0, opacity: 0, scale: 1, rotate: 0 },
        unmounted: { x: 0, opacity: 0, scale: 0, rotate: 0 },
        initial: {
            x: 0,
            opacity: 1,
            scale: 1,
            rotate: 0,
        },
        incorrectWrong: {
            ...inCorrectBase,
            x: [x * 2.5, -x],
            rotate: [10, -10],
        },
        incorrectRight: {
            ...inCorrectBase,
            x: [-(x * 2.5), x],
            rotate: [-10, 10],
        },
        wrong: {
            ...correctBase,
            x,
            rotate: [10, 10],
        },
        right: {
            ...correctBase,
            x: -x,
            rotate: [-10, -10],
        },
    };

    return (
        <motion.div
            styleName="bell"
            initial="unmounted"
            animate={status}
            variants={variants}
            style={{
                background: getTransparentBackground(background),
            }}
            ref={ref}
        >
            <FontAwesomeIcon icon={faBell} />
        </motion.div>
    );
}

export default memo(Bell);
